export default {
  title: '履歴',
  desc: 'プロジェクトのエクスポート、ダウンロード、およびプッシュの履歴を一元的に表示します。',
  exportExc: 'Excelでエクスポート',
  tab1: 'プレイ可能なプロジェクト',
  tab2: 'ビデオプロジェクト',
  tab3: '録画プロジェクト',
  tab4: 'AIプロジェクト',
  record: {
    state: {
      success: 'エクスポート成功',
      exporting: 'エクスポート中',
      fail: 'エクスポート失敗',
    },
    select: {
      name: '作品名',
      projectId: 'プロジェクトID',
      projectName: 'プロジェクト名',
      versionId: 'バージョンID',
      versionName: 'バージョン名',
    },
    table: {
      name: '作品名',
      state: 'エクスポートステータス',
      operation: {
        name: '操作',
        again: '再エクスポート',
        look: 'プレビュー',
        down: 'ダウンロード',
      },
      exportTime: 'エクスポート日時',
      updateTime: '更新日時',
      nameId: 'プロジェクト名およびID',
      versionId: 'バージョン名およびID',
      material: {
        id: '素材ID',
        unsupportAnalyze: '現在の素材は分析機能をサポートしていません',
        analyze: '素材分析',
      },
    },
  },
  video: {
    state: {
      success: 'エクスポート成功',
      exporting: 'エクスポート中',
      fail: 'エクスポート失敗',
      waiting: 'キュー待機中',
      queuing: '待機中',
      completed: '完了',
      partSuccesss: '部分的な成功',
    },
    select: {
      name: '作品名',
      id: 'プロジェクトID',
      projectName: '製品名',
      exportId: 'エクスポートタスクID',
      nameId: '作品ID',
    },
    table: {
      name: '作品名およびID',
      stats: 'エクスポートステータス',
      operations: '操作',
      ProjectId: 'プロジェクト名およびID',
      size: 'サイズ',
      resolution: '解像度',
      fileSize: 'サイズ',
      number: 'プッシュ成功回数',
      exportTime: 'エクスポート日時',
      operation: {
        lookProject: '作品のプレビュー',
        downProject: '作品のダウンロード',
        Mintegral: 'Mintegralにプッシュ',
      },
      pushId: 'プッシュ履歴ID',
      exportStatus: 'タスクステータス',
      pushVideoCounts: 'プッシュ済みのビデオ数',
      pushCounts: 'プッシュ数',
      exportCount: 'エクスポート数',
      pushAgain: '再プッシュ',
      batchDownload: '一括ダウンロード',
      downProject: '作品のダウンロード',
      cancelExport: 'エクスポートをキャンセル',
      cancelMainTitle: 'エクスポート待機中の作品をキャンセルしますか？',
      cancelSubTitle:
        'エクスポートをキャンセルした場合、作品は再度エクスポートできません。',
      againMainTitle: '失敗した作品を再エクスポートしますか？',
      againSubTitle:
        '再エクスポート後、作品はエクスポートキューに再び追加されます。',
      verificationName:
        '一部の作品名が要件に合わないため、数字、アルファベット、アンダースコアのみを含めてください。一括で名前を変更してから再度プッシュしてください。',
      batchRename: '一括ネーミング',
      example: '例',
      newProject: '新規プロジェクトを作成',
    },
    push: {
      channel: 'プッシュチャネル',
      name: 'プッシュ作品名',
      username: 'プッシュアカウントのみ',
    },
    history: {
      table: {
        name: '作品名',
        state: '申請状況',
        operations: '操作',
        channel: '投放チャネル',
        username: 'プッシュアカウント',
        data: 'プッシュ日時',
      },
      push: {
        state: {
          success: 'プッシュ成功',
          feld: 'プッシュ失敗',
          ing: 'プッシュ中',
        },
        Mintegral: 'Mintegralにプッシュ',
      },
    },
    table1: 'エクスポートタスク',
    table2: '作品',
    table3: 'プッシュ履歴',
    pushCountTips: 'プッシュ成功数 / プッシュ済みの作品数',
    pushTime: 'プッシュ日時',
  },
  ai: {
    history: {
      table: {
        taskNameId: 'タスク名とID',
        status: 'ステータス',
        operations: '操作',
        fileCount: '生成数',
        languages: '言語',
        duration: '時間',
        workNameId: '作品名とID',
        download: 'ダウンロード',
        create: '新規ビデオプロジェクトを作成',
        taskName: 'タスク名',
        taskId: 'タスクID',
        workName: '作品名',
        workId: '作品ID',
      },
    },
    table: {
      status: {
        pending: '生成中',
        success: '生成成功',
        failed: '生成失敗',
      },
    },
  },
}
